import { Component } from '@angular/core';

@Component({
  selector: 'app-layers-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './layers-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class LayersIconComponent {}
